import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CarouselThumbs = ({ images, currentIndex, onSelect, placeholder, classes }) => {
    return (
        <div className={classes.thumbnailsWrapper}>
            <div className={classes.thumbnailsContainer}>
                {images.map((image, index) => (
                    <Thumbnail
                        key={index}
                        image={image}
                        index={index}
                        isActive={index === currentIndex}
                        placeholder={placeholder}
                        onSelect={onSelect}
                        classes={classes}
                    />
                ))}
            </div>
        </div>
    );
};

const Thumbnail = memo(({ image, index, isActive, placeholder, onSelect, classes }) => {
    const [hasError, setHasError] = useState(false);

    const handleError = useCallback(() => {
        if (placeholder && !hasError) {
            setHasError(true);
        }
    }, [placeholder, hasError]);

    const handleClick = useCallback(() => {
        onSelect(index);
    }, [index, onSelect]);

    const imageSrc = hasError ? placeholder : image?.thumbnail || image?.original;

    return (
        <button
            type="button"
            className={classnames(classes.thumbnail, {
                [classes.thumbnailActive]: isActive,
            })}
            onClick={handleClick}
        >
            <img
                className={classes.thumbnailImage}
                src={imageSrc}
                alt=""
                onError={handleError}
                draggable={false}
            />
        </button>
    );
});

CarouselThumbs.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            original: PropTypes.string,
            thumbnail: PropTypes.string,
        }),
    ).isRequired,
    currentIndex: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    classes: PropTypes.object.isRequired,
};

export default memo(CarouselThumbs);
